import { useLocation, Navigate } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 45432, offsets 272635:273555. Structure and names inferred from code, not screenshots.
import * as GetLanguageModule from "../i18n/getLanguage.js";
import * as LocalizedPathsModule from "./localizedPaths.js";
function AgreementPage({ fromPrefix: fromPrefix, toPrefix: toPrefix }) {
  let { pathname: pathname, search: search, hash: hash } = useLocation(),
    d = (function (e, t, i, n, o) {
      let a = String(n ?? "")
          .trim()
          .replaceAll(/^\/+|\/+$/g, ""),
        l = String(o ?? "")
          .trim()
          .replaceAll(/^\/+|\/+$/g, "");
      if (!a || !l) return null;
      let s =
          "string" != typeof e
            ? ""
            : e.length > 1 && e.endsWith("/")
              ? e.slice(0, -1)
              : e,
        c = (0, LocalizedPathsModule.z9)(e) ?? "/docs",
        d = (e) => {
          let n = `${c}/${e}/${a}`;
          if (s === n) return `${c}/${e}/${l}${t}${i}`;
          if (s.startsWith(`${n}/`)) {
            let o = s.slice(n.length);
            return `${c}/${e}/${l}${o}${t}${i}`;
          }
          return null;
        };
      return (
        d("zh-CN") ||
        d("en-US") ||
        (() => {
          let e = `${c}/${a}`;
          if (s === e) return `${c}/${l}${t}${i}`;
          if (s.startsWith(`${e}/`)) {
            let n = s.slice(e.length);
            return `${c}/${l}${n}${t}${i}`;
          }
          return null;
        })()
      );
    })(pathname, search, hash, fromPrefix, toPrefix);
  return null == d ? (
    <Navigate
      to={(0, LocalizedPathsModule.am)(
        (0, LocalizedPathsModule.Oz)((0, GetLanguageModule.getLanguage)()),
        "welcome",
      )}
      replace={true}
    />
  ) : (
    <Navigate to={d} replace={true} />
  );
}
export { AgreementPage };
